export class SideNav {
    el;
    menuWrapper;
    contentWrapper;
    menuItems;
    mobileMenuItems;
    pageSections;
    activeSection;
    controlButton;
    activeSectionElement;
    constructor(el) {
        this.el = el;
        this.activeSection = 0;
        this.controlButton = this.el.querySelector('.mobile-side-nav-control');
        this.menuWrapper = this.el.querySelector('.side-nav-wrapper-mobile');
        this.contentWrapper = this.el.querySelector('.side-nav-content-wrapper');
        this.menuItems = Array.from(this.el.querySelectorAll('.side-menu-item'));
        if (this.menuItems.length > 0) {
            this.menuItems[0].classList.add('active');
        }
        this.mobileMenuItems = Array.from(this.el.querySelectorAll('.side-menu-item-mobile'));
        if (this.mobileMenuItems.length > 0) {
            this.mobileMenuItems[0].classList.add('active');
        }
        this.pageSections = this.menuItems.map(item => {
            const targetHref = item.getAttribute('href');
            return this.contentWrapper.querySelector(targetHref);
        });
        window.addEventListener("scroll", () => {
            this.scrollCheck();
        });
        this.navBind();
        const mobileNav = this.el.querySelector('.mobile-side-nav');
        if (mobileNav) {
            const observer = new IntersectionObserver(this.onObserve.bind(this), { threshold: [1] });
            observer.observe(mobileNav);
        }
    }
    scrollCheck() {
        const countItems = this.pageSections.length;
        for (let index = countItems - 1; index >= 0; index--) {
            const section = this.pageSections[index];
            // Spacing to content top = 112 
            if (section.getBoundingClientRect().top <= 112) {
                if (index !== this.activeSection) {
                    this.activeSection = index;
                    this.updateNav();
                }
                return;
            }
        }
    }
    onObserve(entries, observer) {
        const mobileNav = this.el.querySelector('.mobile-side-nav');
        for (const { target, isIntersecting, intersectionRatio, boundingClientRect } of entries) {
            if (boundingClientRect.top <= -0 && intersectionRatio < 1) {
                mobileNav.classList.add('is-sticky');
                setTimeout(() => {
                    this.collapse(this.menuWrapper);
                    this.controlButton?.querySelector('.svg-wrapper')?.classList.add('rotate-180');
                }, 400);
                return;
            }
            else {
                mobileNav.classList.remove('is-sticky');
            }
        }
    }
    updateNav() {
        this.menuItems.forEach((item, index) => {
            if (index === this.activeSection) {
                item.classList.add('active');
            }
            else {
                item.classList.remove('active');
            }
        });
        this.mobileMenuItems.forEach((item, index) => {
            if (index === this.activeSection) {
                item.classList.add('active');
            }
            else {
                item.classList.remove('active');
            }
        });
    }
    navBind() {
        if (this.controlButton) {
            this.controlButton.addEventListener('click', e => {
                e.preventDefault();
                const isExpanded = this.controlButton.getAttribute('aria-expanded') == 'true';
                this.toggle(isExpanded);
            });
        }
        if (this.mobileMenuItems) {
            this.mobileMenuItems.forEach((ele) => {
                ele.addEventListener('click', (e) => {
                    this.collapse(this.menuWrapper);
                });
            });
        }
    }
    toggle(isExpanded = false) {
        if (!isExpanded) {
            this.controlButton.setAttribute('aria-expanded', 'true');
            this.expand(this.menuWrapper);
        }
        else {
            this.collapse(this.menuWrapper);
        }
    }
    collapse(element) {
        this.controlButton?.querySelector('.svg-wrapper')?.classList.add('rotate-180');
        // get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight;
        // temporarily disable all css transitions
        const elementTransition = element.style.transition;
        element.style.transition = '';
        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function () {
            element.style.height = sectionHeight + 'px';
            element.style.transition = elementTransition;
            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(function () {
                element.style.height = 0 + 'px';
            });
        });
        setTimeout(() => {
            this.controlButton.setAttribute('aria-expanded', 'false');
        }, 600);
        // mark the section as "currently collapsed"
        element.classList.remove('is-expanded');
        element.setAttribute('data-collapsed', 'true');
    }
    expand(element) {
        this.controlButton?.querySelector('.svg-wrapper')?.classList.remove('rotate-180');
        // Get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight;
        // have the element transition to the height of its inner content
        element.style.height = sectionHeight + 'px';
        // when the next css transition finishes (which should be the one we just triggered)
        const transitionend = () => {
            // remove this event listener so it only gets triggered once
            element.removeEventListener('transitionend', transitionend);
        };
        element.addEventListener('transitionend', transitionend, false);
        // mark the section as "currently not collapsed"
        element.classList.add('is-expanded');
        element.setAttribute('data-collapsed', 'false');
    }
}
